import { useDispatch, useSelector } from 'react-redux';
import { SET_WIDTH_ACTION } from '../../modules/Device';

const useDevice = () => {
  const { width, isMobile } = useSelector(state => state.device);
  const dispatch = useDispatch();

  const setSize = px => {
    dispatch(SET_WIDTH_ACTION(px));
  };

  return { width, isMobile, setSize };
};

export default useDevice;
